import React, { Component } from 'react';
import { Link } from 'react-router'
import ContentWrapper from '../../components/Layout/ContentWrapper';
import {reset} from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';
// Helper function to check the fields are valid or not.

function checkValid(elem) {
    return elem.touched && elem.invalid ? 'has-danger' : ''
}

class UserForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };



    onSubmit(props) {
        this.props.createUsers(props)
            .then(() => {
                this.context.router.push('/users');
            });
    }

    // If the url is ".../users/new", return a blank form with title of new user.
    // If the url comes with a userID, the form will be filled with title of edit
    // user corresponding information.

    componentDidMount() {
        if (this.props.params.id) {
            const { name, email, phone, address} = this.props.user;
            this.props.fields.name.onChange(name);
            this.props.fields.email.onChange(email);
            this.props.fields.phone.onChange(phone);
            this.props.fields.address.city.onChange(address.city);
            this.props.fields.address.street.onChange(address.street);
        } else {
            reset('userForm');
        }
    }

    title() {
        if (!this.props.params.id) {
            return <h3><Translate value="create_a_new_user" /></h3>
        }
        return <h3><Translate value="edit_user" /></h3>
    }

    render() {
        const { fields: { name, email, phone, address}, handleSubmit } = this.props;
        return (
            <ContentWrapper>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this)) } >
                    {this.title() }
                    <div className={`form-group ${checkValid(name)}`}>
                        <label><Translate value="name" /></label>
                        <input type="text" className="form-control" {...name}/>
                        <div className="text-help">
                            {name.touched ? name.error : ''}
                        </div>
                    </div>
                    <div className={`form-group ${checkValid(email)}`}>
                        <label><Translate value="email" /></label>
                        <input type="text" className="form-control" {...email}/>
                        <div className="text-help">
                            {email.touched ? email.error : ''}
                        </div>
                    </div>
                    <div className={`form-group ${checkValid(phone)}`}>
                        <label><Translate value="phone" /></label>
                        <input type="text" className="form-control" {...phone}/>
                        <div className="text-help">
                            {phone.touched ? phone.error : ''}
                        </div>
                    </div>
                    <div className={`form-group ${checkValid(address.city)}`}>
                        <label><Translate value="city" /></label>
                        <input type="text" className="form-control" {...address.city}/>
                    </div>
                    <div className={`form-group ${checkValid(address.street)}`}>
                        <label><Translate value="street" /></label>
                        <input type="text" className="form-control" {...address.street}/>
                    </div>
                    <button type="submit" className="btn btn-primary" ><Translate value="submit" /></button>
                    <Link to="/users" className="btn btn-danger buttonStyle"><Translate value="cancel" /></Link>
                </form>
            </ContentWrapper>
        )
    }
}

export default UserForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Users/userForm.jsx